<template>
    <div class="columns">
        <section class="section column is-2 menu-background">
            <Menu />
        </section>
        <section class="column is-10">

            <div class="navbar-custom-pc">
                <NavBar />
            </div>
            <div>
                <div class="level">
                    <div class="level-left">
                        <div class="level-item">
                            <span class="is-size-3 has-text-weight-bold">Update Family</span>

                        </div>
                    </div>
                </div>
                <form @submit.prevent="updateFamily">
                    <section>
                       
                        <b-field label="Family Name">
                            <b-input v-model="family_name" required placeholder="Basin" icon-pack="fas"
                                icon="fas fa-boxes"></b-input>
                        </b-field>

                    </section>
                    <footer class="modal-card-foot">
                        <b-button class="button" @click="goBack()" icon-pack="fas" icon-right="fas fa-times"
                        type="is-danger">
                        Cancel</b-button>
                    <b-button class="button is-primary" icon-pack="fas" native-type="submit" :loading="isLoading"
                        icon-right="fas fa-check">Update</b-button>
                    </footer>
                    
                </form>
            </div>
        </section>
    </div>
</template>

<script>
import NavBar from '@/components/NavBar.vue'
import Menu from '@/components/Menu.vue'
export default {
    name: "UpdateFamily",
    components: {
        NavBar,
        Menu
    },
    data() {
        return {
            family_name:null,
            isLoading: false,
            family_id:null
        }
    },
    mounted(){
        this.family_id = this.$route.params.family_id
        this.family_name = this.$route.params.family_name
    },
    methods: {
        updateFamily() {
            if (this.family_name) {
                this.isLoading = true
                this.$store.dispatch('updateFamily', {
                        family_id:this.family_id,
                        family_name: this.family_name,
                    })
                    .then((response) => {
                        if (response.error == 0) {
                            this.ToastSuccess("Family updated")
                        } else {
                            this.ToastError("Family updation failed")
                        }
                    })
                    .catch(() => {
                        this.ToastError("Family updation failed")
                    })
                    .finally(() => {
                        this.isLoading = false
                    })

            } else {
                this.ToastError("Please fill required fields")
            }
        },
        goBack(){
            this.$router.go(-1)
        }
    }
}
</script>

<style>
/* .menu-background{
    background-color: #26547C;
} */
</style>